<template>
  <div>
    <!-- <waiterHomeScreen v-if="userType == 2" /> -->
    <userDashBoard v-if="userType == 2" @loadingChange="(e)=> $emit('loadingChange',e)"/> 
  </div>
</template>
<script>
// import todaySpecial from "@/components/wesupport/todaysSpecial";
import userDashBoard from "@/components/wesupport/userDashBoard";
import waiterHomeScreen from "./waiterHomeScreen";
import { getUserType } from "@/utils/auth";
export default {
  components: { userDashBoard, waiterHomeScreen },
  data: () => ({
    userType: 0,
  }),
  mounted() {
    this.$emit("setBottomNav", 0);
    this.$emit("changeHeader","<span style='color:#e01c24'>we</span><span style='color:#244493'>support</span>");
    this.userType = getUserType();
  },
  methods: {},
};
</script>
<style>
.try::before{
content: "";
width: 50px;
height: 50px;
}
</style>
